import React from 'react'
import { Outlet } from 'react-router-dom'

import { User } from '../../../models/User'
import { NavLink } from './NavLink'
import Sidebar from './Sidebar'

type NavigationPageProps = React.ComponentPropsWithoutRef<'div'> & {
    links: NavLink[]
    user?: User
    shouldDisableLayout?: boolean
}

const NavigationPage = ({
    links,
    user,
    shouldDisableLayout = false,
    ...props
}: NavigationPageProps) => {
    return (
        <div
            className="grid h-screen w-screen grid-cols-[auto_1fr] grid-rows-1 overflow-hidden"
            data-testid="page-container"
            {...props}
        >
            <Sidebar links={links} user={user} />
            {shouldDisableLayout ? (
                <Outlet />
            ) : (
                <main
                    className="flex justify-center overflow-y-auto bg-gray-100 p-8"
                    id="pocket-suite-main"
                >
                    <div className="max-w-xlarge h-fit w-full" data-testid="content-container">
                        <Outlet />
                    </div>
                </main>
            )}
        </div>
    )
}

export default NavigationPage
